import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext } from 'react';
import { useQuery } from 'urql';
import PropTypes from 'prop-types';
import { Confirm } from './Confirm';
import { getKit } from './queries';
import { Kit } from './Kit';
import { KitContext, KitContextProvider } from './context';
import { Overview } from './Overview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Steps = function Steps() {
  var _useContext = useContext(KitContext),
      kit = _useContext.kit,
      step = _useContext.step,
      setStep = _useContext.setStep,
      totalSteps = _useContext.totalSteps;

  if (step === 0) {
    return /*#__PURE__*/_jsx(Overview, {
      cta: "Build Your Kit",
      kit: kit,
      onClick: function onClick() {
        return setStep(step + 1);
      }
    });
  }

  if (step === totalSteps + 1) {
    return /*#__PURE__*/_jsx(Confirm, {});
  }

  return /*#__PURE__*/_jsx(Kit, {});
};

export var KitLoader = function KitLoader(_ref) {
  var handle = _ref.handle,
      loadingHTML = _ref.loadingHTML,
      shopifyId = _ref.shopifyId;

  var _useQuery = useQuery({
    query: getKit,
    variables: {
      shopifyId: shopifyId,
      handle: handle
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      error = _useQuery2$.error,
      fetching = _useQuery2$.fetching;

  if (fetching) {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: loadingHTML
      }
    });
  }

  if (error) {
    console.error(error);
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h2", {
        children: "Oops...Something went wrong."
      }), /*#__PURE__*/_jsx("p", {
        children: error.message
      })]
    });
  }

  var initialState = [];
  var totalSteps = data.kit.collections.edges.length;
  data.kit.collections.edges.forEach(function (product) {
    var productNode = product.node;
    var firstProduct = productNode.products.edges[0].node;
    var options = productNode.products.edges.map(function (_ref2) {
      var node = _ref2.node;
      return {
        product: node.product,
        colorwayId: node.faceout.id
      };
    });
    var colorwayId = firstProduct.faceout.id;
    initialState.push({
      colorwayId: colorwayId,
      options: options,
      productId: firstProduct.product.id,
      sizeSelected: false
    });
  });
  return /*#__PURE__*/_jsx(KitContextProvider, {
    kit: data.kit,
    initialState: initialState,
    totalSteps: totalSteps,
    children: /*#__PURE__*/_jsx(Steps, {})
  });
};
KitLoader.propTypes = {
  handle: PropTypes.string,
  loadingHTML: PropTypes.string,
  shopifyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};